import { takeLatest, put, call, select } from 'redux-saga/effects';
import { REMOVE_DEBT_WORKOUT_SAGA } from "../sagaTypes";
import { loaderAction, removeDebtAction } from "../rootReducer";
import { url } from "../../config";
import growl from "../../lib/growl/growl";
import { setLocalStorage } from "../../helpers/LocalStorage";
import { getUserInfoSagaAction } from "../sagaActions";
import { REMOVE_DEBT_INITIAL } from "../initialStateConstant";

const request = data => {
    return fetch(`${ url }/remove_debt_workout`, {
        method: 'post',
        body: data
    })
        .then(response => response.json()).catch(error => console.log(error))
};

function* workerRemoveDebtWorkout(args) {
    const user = yield select(state => state.user);

    yield put(loaderAction(true));
    try {
        let formData = new FormData();
        formData.append('user_id', user.id);
        formData.append('hash', user.hash);

        formData.append('workout_id', args.data.workout_id);
        formData.append('subscription_id', args.data.subscription_id || '');

        const response = yield call (request, formData);

        // Если не прошли проверку хеша разлогиниваемся
        if (response.void) {
            setLocalStorage('afp_fitness', '').then(() => window.location.reload());
        }

        if (response.success) {
            // Закрываем окно removeDebt
            yield put(removeDebtAction(REMOVE_DEBT_INITIAL));
            // Обновляем информацию о пользователе
            yield put(getUserInfoSagaAction({ id: args.data.user }));
            growl({ type: 'success', message: response.message });
        }
        else if (response.error) {
            growl({ type: 'error', message: response.message });
        }
    }
    catch(error) {
        console.log(error);
        yield put(loaderAction(false));
    }
    finally {
        yield put(loaderAction(false));
    }
}

export default function* watcherRemoveDebtWorkout() {
    yield takeLatest(REMOVE_DEBT_WORKOUT_SAGA, workerRemoveDebtWorkout);
}